<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="blockIpsModal" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="twoFAStepModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="twoFAStepModalHeader">Block New IP or IP Range</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="loading" class="loader"/>
            <form v-else @submit.prevent="blockIp">
              <div class="row">
                <div class="col-md-12">
                  <b>Allowed format is:</b>
                  <ul class="list-unstyled">
                    <li><small>IP: 1.2.3.4</small></li>
                    <li><small>IP Range: 1.2.3.1/24</small></li>
                  </ul>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Enter IP or IP-Range</label>
                    <input type="text" class="form-control" required v-model.trim="ip">
                  </div>
                  <button class="btn btn-primary" type="submit" >Block</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
const validate = require('ip-validator');
export default {
name: "unBlockIpsModal",
  data () {
    return {
      ip: null,
      loading: false
    }
  },
  methods: {
    load () {
      $('#blockIpsModal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    async blockIp () {
      this.loading = true
      const slashArray = this.ip.split('/');
      if (slashArray.length === 1 && validate.ipv4(this.ip)) {
        await this.$parent.blockIp(this.ip)
      } else if (slashArray.length === 2 && validate.ipv4(slashArray[0]) && !isNaN(parseInt(slashArray[1])) && parseInt(slashArray[1]) % 1 === 0) {
        await this.$parent.blockIp(this.ip)
      } else {
        this.loading = false
        return swal({
          title: "Error",
          text: 'IP format is not valid!',
          type: "error",
        });
      }
      this.ip = null
      $('#blockIpsModal').modal('hide');
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>
